// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Toast_wrap__zUU2P","toast":"Toast_toast__5vjwy","title":"Toast_title__MIB8o","desc":"Toast_desc__IEE9F","actions":"Toast_actions__ladd3","icon":"Toast_icon__kk9_a"};